import { selectKpData } from 'shared/selectors/offerData/kp';
import { IState } from 'shared/store';

export const selectKpId = (state: IState): number | null => {
  const kp = selectKpData(state);

  return kp?.id || null;
};
